<template>
  <van-popup v-model="servicePopShow" round position="bottom">
    <p class="service-popup-title">
      学而思1对1服务
      <img
        @click="servicePopShow = false"
        src="../../../assets/img/class/close.png"
      />
    </p>
    <div
      class="service-popup-info"
      v-for="(item, index) in serviceList"
      :key="index"
    >
      <p>{{ item.title }}</p>
      <p>{{ item.remark }}</p>
      <img :src="item.icon" />
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    serviceShow: {
      type: Boolean,
      default: false,
    },
    serviceList: {
      type: Array,
    },
  },
  data() {
    return {
      servicePopShow: this.serviceShow,
    };
  },
  mounted() {},
  methods: {},
  watch: {
    serviceShow(newValue) {
      this.servicePopShow = newValue;
    },
    servicePopShow(newValue) {
      this.$emit("update:serviceShow", newValue);
    },
  },
};
</script>
<style scoped lang="scss">
.service-popup-title {
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-size: 11.8px;
  font-weight: 500;
  color: #212832;
  position: relative;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 17px;

  img {
    width: 40px;
    height: 40px;
    padding: 12px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.service-popup-info {
  position: relative;
  padding: 0 12px 17px 38px;
  img {
    position: absolute;
    left: 12px;
    top: 0;
    width: 18px;
    height: 18px;
  }
  p:first-child {
    line-height: 18px;
    font-size: 11px;
    font-weight: 600;
    color: #212832;
  }
  p:nth-child(2) {
    font-size: 9px;
    font-weight: 400;
    color: #8e959e;
    line-height: 13px;
    margin-top: 4px;
  }
}
.service-popup-info:last-child {
  padding-bottom: 34px;
}
</style>
